export default [
  //登录-邮箱登录
  {
    path: "/:lang/login/email",
    name: "Email",
    hidden: true,
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      modulsName: "login_email",
      noPermissionValidate: true,
      keepAlive: false,
      isLoaded: false,
    },
    component: () => import("/@/views/login/email.vue"),
  },
  //登录-手机号登录
  {
    path: "/:lang/login/tel",
    hidden: true,
    name: "Tel",
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      modulsName: "login_tel",
      noPermissionValidate: true,
      keepAlive: false,
      isLoaded: false,
    },
    component: () => import("/@/views/login/tel.vue"),
  },
  //微信登录绑定
  {
    path: "/:lang/userBind/wechart",
    name: "wechartuserBind",
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      modulsName: "userBind_wechart",
      noPermissionValidate: true,
      keepAlive: false,
      isLoaded: false,
    },
    component: () => import("/@/views/login/bindwechart.vue"),
  },
  // 忘记密码
  {
    path: "/:lang/login/forgetPassword",
    name: "forgetPassword",
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      modulsName: "login",
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/login/forgetPassword.vue"),
  },
  // 修改密码
  {
    path: "/:lang/login/changePassword",
    name: "changePassword",
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      modulsName: "login",
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/login/changePassword.vue"),
  },
  // 账号信息修改
  {
    path: "/:lang/Account/Edit/Index",
    alias: [
      "/:lang/Account/Edit/Index",
      "/:lang/Account/Edit/Index",
      "/:lang/Account/Edit/Index",
      "/:lang/Account/Edit/Index",
    ],
    name: "accountEdit",
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      modulsName: "account",
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Account/edit.vue"),
  }
];
